import { getAirPlayEligibility } from './airplay-policy.js';

// Eligibility only: source authorization and completed, permitted VTT filtering belong to the caller.
export function getCastEligibility({
  source, duration, currentTime, accessExpiresAt = null,
  activeSubtitle = null, vttAssets = [], hasAudioDescription = false,
  airPlayActive = false, nowMs = Date.now(),
}) {
  const media = getAirPlayEligibility({
    url: source?.url, duration, currentTime, accessExpiresAt,
    hasSubtitle: false, nowMs, pauseAllowanceMs: 0,
  });
  const result = (reason, expiresAtMs = media.expiresAtMs, captionAssetId = null) => ({
    allowed: reason === null, reason, expiresAtMs, captionAssetId,
  });
  if (airPlayActive) return result('airplay_active');
  if (hasAudioDescription) return result('audio_description');
  if (!source?.url) return result('unknown_expiry');
  if (typeof source.mimetype !== 'string' || !source.mimetype.trim()) {
    return result('unsupported_source');
  }
  if (!media.allowed) return result(media.reason);
  if (activeSubtitle === null) return result(null);

  // Never discard an unsupported selected accessibility option to permit handoff.
  const caption = !activeSubtitle.isTranscript && activeSubtitle.id != null &&
    Array.isArray(vttAssets) && vttAssets.find(asset => asset &&
      asset.id === activeSubtitle.id && asset.url === activeSubtitle.url);
  if (!caption) return result('unsupported_captions');
  const captionValidity = getAirPlayEligibility({
    url: caption.url, duration, currentTime, accessExpiresAt,
    hasSubtitle: false, nowMs, pauseAllowanceMs: 0,
  });
  if (!captionValidity.allowed) return result('caption_validity');
  return result(null, Math.min(media.expiresAtMs, captionValidity.expiresAtMs), caption.id);
}
